module.exports = __webpack_public_path__ + "img/huiyuan.91fcb888.svg";